const latestArticle = {
  "status": "true",
  "message": "取得最新文章",
  "total": "3",
  "ArticleList": [
    {
      "title": "IEKView: Green Transformation of Machine Tools to Improve Energy Efficiency",
      "author": "Chia-Meng Chen 、Chih-Min Hsiung",
      "url": "https://ieknet.iek.org.tw/iekrpt/rpt_detail.aspx?indu_idno=15&domain=51&rpt_idno=480187620 ",
      "image": `${require('assets/images/home/news-1.jpg')}`
    },
    {
      "title": "IEK360系列 | 從歐盟淨零工業法案看歐盟近期產業政策發展",
      "author": "林志勳",
      "url": "https://ieknet.iek.org.tw/iekppt/ppt_detail.aspx?actiontype=ppt&indu_idno=5&domain=28&sld_preid=7663",
      "image": `${require('assets/images/home/news-2.jpg')}`
    },
    {
      "title": "IEK360系列 | 碳定價機制下的新興市場：抓住碳商機的策略與挑戰",
      "author": "紀佳妤",
      "url": "https://ieknet.iek.org.tw/iekppt/ppt_detail.aspx?actiontype=ppt&indu_idno=5&domain=28&sld_preid=7654",
      "image": `${require('assets/images/home/news-3.jpg')}`
    },
  ]
}

export default latestArticle;